import { fetchJson } from "./fetchJson";

type QfcAvailabilityResponse = {
  isVariantAvailable: boolean;
};

type ProductFormElement = Element & {
  handleErrorMessage: (errorMessage?: string | false) => void;
};

const isProductFormElement = (
  element: Element | null,
): element is ProductFormElement =>
  !!element && "handleErrorMessage" in element;

const setSubmitButtonAvailable = (
  submitButton: HTMLButtonElement,
  isAvailable: boolean,
): void => {
  const addToCartLabel = submitButton.querySelector<HTMLElement>(
    "span:not(.sold-out-message)",
  );
  const soldOutLabel =
    submitButton.querySelector<HTMLElement>(".sold-out-message");

  submitButton.disabled = !isAvailable;
  submitButton.toggleAttribute("aria-disabled", !isAvailable);
  addToCartLabel?.classList.toggle("hidden", !isAvailable);
  soldOutLabel?.classList.toggle("hidden", isAvailable);
};

const checkVariantAvailability = async (
  select: HTMLSelectElement,
): Promise<void> => {
  const quickAdd = select.closest(".quick-add");
  const submitButton = quickAdd?.querySelector<HTMLButtonElement>(
    "[data-quick-add-variant-submit]",
  );
  if (!submitButton) return;

  const variantId = select.value;
  if (!variantId) {
    setSubmitButtonAvailable(submitButton, true);
    return;
  }

  const productForm = quickAdd?.querySelector("product-form") ?? null;
  if (isProductFormElement(productForm)) productForm.handleErrorMessage();

  const productUrl = select.dataset.productUrl;
  if (!productUrl) return;

  const url = `${productUrl}?variant=${encodeURIComponent(variantId)}&view=qfc-availability`;
  const availability = await fetchJson<QfcAvailabilityResponse>(url);
  if (!availability) return;

  if (select.value !== variantId) return;

  setSubmitButtonAvailable(submitButton, availability.isVariantAvailable);
};

document.addEventListener("change", (event) => {
  const target = event.target;
  if (
    !(target instanceof HTMLSelectElement) ||
    !target.hasAttribute("data-quick-add-variant-select")
  )
    return;

  void checkVariantAvailability(target);
});
